let oidcUser = null;

export const setOidcUser = (user) => {
  oidcUser = user;
};

export const getOidcToken = () => {
  return oidcUser?.id_token;
};
